/*
 * Register the ProsthoAI static-shell service worker (Mobile PWA Batch B2).
 *
 * Guardrails:
 *   • Only runs in browsers that support Service Worker (skips Safari <11.1
 *     and legacy WebViews).
 *   • Registration is idempotent; the browser reuses the existing worker
 *     unless `SW_VERSION` in `/service-worker.js` was bumped.
 *   • `updateViaCache: 'none'` guarantees the SW script itself is always
 *     revalidated so version bumps roll out immediately.
 *   • Silent on failure — a missing SW must NEVER block the app from
 *     rendering. Failure is logged to the console and swallowed.
 *
 * PHI note: this file only wires up registration. The SW itself is
 * responsible for enforcing the "never cache /api/*" contract.
 */

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Defer registration until the app has painted so we never race first
  // contentful paint on the iPhone.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/", updateViaCache: "none" })
      .then((reg) => {
        // Poll for updates on visibilitychange — cheap way to pick up a
        // new SW_VERSION when the clinician returns to the tab.
        if (typeof document !== "undefined") {
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
              reg.update().catch(() => {});
            }
          });
        }
      })
      .catch((err) => {
        // Best-effort only — never surface to the user.
        if (typeof console !== "undefined" && console.info) {
          console.info("[sw] registration skipped:", err && err.message);
        }
      });
  });
}
